<template>
  <div>
    <a-drawer title="图片编辑" placement="right" :visible="isVisibleDrawer" @close="onDrawerClose" width="800">
      <a-table
        bordered
        :columns="columns"
        :data-source="tableDataComputed"
        rowKey="materialCode"
        :pagination="false"
      ></a-table>
      <div class="picture-list-div">
        <a-upload
          list-type="picture-card"
          :file-list="fileList"
          :customRequest="upload"
          :beforeUpload="beforeUpload"
          :remove="removeFile"
          multiple
          @preview="handlePreview"
          @change="handleChange"
        >
          <div>
            <a-icon type="plus" />
            <div class="ant-upload-text">上传图片</div>
          </div>
        </a-upload>
      </div>
      <div class="a-drawer-foot">
        <a-button :style="{ marginRight: '8px' }" @click="onDrawerClose"> 取消 </a-button>
        <a-button type="primary" @click="onSaveImage" :loading="isSaveBtnLoadding"> 保存 </a-button>
      </div>
    </a-drawer>
    <a-modal :visible="previewVisible" :footer="null" @cancel="onPreviewClose">
      <div class="preview-icon-divflex">
        <div class="preview-icon-left" @click="previewSeeChange('last')">
          <a-icon style="font-size: 50px" type="left" />
        </div>
        <div class="preview-icon-right" @click="previewSeeChange('next')">
          <a-icon style="font-size: 50px" type="right" />
        </div>
      </div>
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
import { uploadMaterialFile, updateMaterialImageData } from '@/api/api'

const columns = [
  {
    title: '物料编码',
    dataIndex: 'materialCode',
    ke: 'materialCode',
    width: 30,
  },
  {
    title: '物料分组编码',
    dataIndex: 'materialGroupCode',
    ke: 'materialGroupCode',
    width: 30,
  },
  {
    title: '物料名称',
    dataIndex: 'materialName',
    ke: 'materialName',
    width: 200,
  },
]
export default {
  data() {
    return {
      isVisibleDrawer: false,
      columns: columns,
      fileList: [],
      previewVisible: false,
      previewIndex: 0,
      previewImage: '',
      materialSelectItem: {
        materialCode: '',
        materialGroupCode: '',
        materialName: '',
        imagePath: '',
      },
      addImagePathList: [],
      deleteImagePathList: [],
      isSaveBtnLoadding: false,
    }
  },
  methods: {
    onDrawerOpen(item) {
      this.materialSelectItem = item
      let fileListTemp = []
      if (this.materialSelectItem.imagePath) {
        let imageArrTemp = this.materialSelectItem.imagePath.split(';')
        for (let i = 0; i < imageArrTemp.length; i++) {
          if (!imageArrTemp[i]) {
            continue
          }
          fileListTemp.push({
            uid: '-' + (i + 1),
            name: 'image.png',
            status: 'done',
            url: imageArrTemp[i],
          })
        }
      }
      this.fileList = fileListTemp
      this.isVisibleDrawer = true
    },
    onDrawerClose() {
      if (this.addImagePathList.length > 0 || this.deleteImagePathList.length > 0) {
        this.$antdConfirm({
          title: '您有未保存的图片，您是否放弃保存？',
          onOk: () => {
            this.addImagePathList = []
            this.deleteImagePathList = []
            this.isVisibleDrawer = false
          },
          onCancel: () => {},
        })
        return
      }
      this.isVisibleDrawer = false
    },
    onPreviewClose() {
      this.previewVisible = false
    },
    handleCancel() {
      this.onDrawerClose()
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      for (let i = 0; i < this.fileList.length; i++) {
        if (file.uid === this.fileList[i].uid) {
          this.previewIndex = i
          break
        }
      }
      this.previewVisible = true
    },
    beforeUpload(file) {},
    handleChange({ fileList }) {
      this.fileList = fileList
    },
    upload(data) {
      console.log(data)
      const formData = new FormData()
      formData.append('file', data.file)
      formData.append('materialCode', this.materialSelectItem.materialCode)
      let config = {
        onUploadProgress: (ProgressEvent) => {
          let progressPercent = (ProgressEvent.loaded / ProgressEvent.total) * 100
          data.onProgress(progressPercent)
        },
      }
      uploadMaterialFile(formData, config)
        .then((res) => {
          if (res.success) {
            data.onSuccess()
            for (let i = this.fileList.length - 1; i >= 0; i--) {
              if (this.fileList[i].lastModified && this.fileList[i].lastModified == data.file.lastModified) {
                this.fileList[i].url = res.result.addImagePath.replace(';', '')
                this.fileList[i].tagAdd = 'add'
                this.addImagePathList.push(res.result.addImagePath.replace(';', ''))
                break
              }
            }
          } else {
            // this.fileList.pop()
            data.onError()
            this.$message.warning(res.message)
          }
        })
        .catch((error) => {
          data.onError()
          // this.fileList.pop()
          this.$message.warning(error)
        })
      return true
    },
    removeFile(file) {
      return new Promise((resolve, reject) => {
        this.$antdConfirm({
          title: '确定要删除这张照片吗?',
          onOk: () => {
            this.deleteImagePathList.push(file.url)
            resolve(true)
          },
          onCancel: () => {
            resolve(false)
          },
        })
      }).catch((error) => {
        this.$message.warning(reason)
      })
    },
    onSaveImage() {
      if (this.addImagePathList.length == 0 && this.deleteImagePathList.length == 0) {
        this.$message.warning('您当前没有修改，不需要保存')
        return
      }
      let dataTemp = {
        materialCode: this.materialSelectItem.materialCode,
      }
      if (this.addImagePathList.length > 0) {
        let addImagePathStr = ''
        dataTemp.addImagePath = this.addImagePathList.join(';') + ';'
      }
      if (this.deleteImagePathList.length > 0) {
        let deleteImagePathStr = ''
        dataTemp.deleteImagePath = this.deleteImagePathList.join(';') + ';'
      }
      this.isSaveBtnLoadding = true
      updateMaterialImageData(dataTemp)
        .then((res) => {
          this.isSaveBtnLoadding = false
          if (res.success) {
            this.$message.success(res.message)
            this.addImagePathList = []
            this.deleteImagePathList = []
            this.updataImage(res.result.imagePath)
          } else {
            this.$message.warning('保存失败')
            this.$message.warning(res.message)
          }
        })
        .catch((error) => {
          this.$message.warning(error)
          this.isSaveBtnLoadding = false
        })
    },
    updataImage(dataImageStr) {
      this.$emit('updataTableImage', this.materialSelectItem.materialCode, dataImageStr)
    },
    previewSeeChange(type) {
      switch (type) {
        case 'next':
          this.previewIndex--
          if (this.previewIndex == -1) {
            this.previewIndex = this.fileList.length - 1
          }
          this.handlePreview(this.fileList[this.previewIndex])
          break
        case 'last':
          this.previewIndex++
          if (this.previewIndex >= this.fileList.length) {
            this.previewIndex = 0
          }
          this.handlePreview(this.fileList[this.previewIndex])
          break
        default:
          break
      }
    },
  },
  computed: {
    tableDataComputed() {
      return [this.materialSelectItem]
    },
  },
}
</script>

<style>
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.picture-list-div {
  position: relative;
  top: 60px;
}
.preview-icon-divflex {
  display: flex;
  justify-content: space-around;
}
.preview-icon-right {
  display: inline-block;
  right: 5px;
  width: 70px;
  height: 70px;
  background-color: rgba(123, 123, 123, 0.5);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.preview-icon-left {
  display: inline-block;
  left: 5px;
  width: 70px;
  height: 70px;
  background-color: rgba(123, 123, 123, 0.5);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.a-drawer-foot {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
</style>
